import { type FC } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { type VocabularyTerm } from './vocabularyTypes'

interface RemoveTermModalProps {
  term: VocabularyTerm
  onHide: () => void
  onConfirm: (term: VocabularyTerm) => void
}

export const RemoveTermModal: FC<RemoveTermModalProps> = ({ term, onHide, onConfirm }) => {
  const modalHeader = (
    <div className='d-flex justify-content-between align-items-center'>
      <h5 className='fs-4 zocks-px-0.25'>Remove "{term.term}"?</h5>
    </div>
  )

  const modalBody = (
    <div className='d-flex flex-column zocks-gap-1 pt-4'>
      <div className='paragraph-medium'>
        The AI Assistant will stop using <b>{term.term}</b> as a hint when transcribing meetings. You can add it again at any time.
      </div>
    </div>
  )

  return (
    <Modal
      show
      onHide={onHide}
      header={modalHeader}
      body={modalBody}
      bodyClassName='border-top'
      showFooterActions
      onFooterPrimaryAction={() => onConfirm(term)}
      footerPrimaryActionTitle='Remove term'
      footerPrimaryActionButtonVariant='danger'
      onFooterSecondaryAction={onHide}
      footerSecondaryActionTitle='Cancel'
    />
  )
}
